// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3o7Mw","signatureButtonsRight":"ModalSign_signatureButtonsRight__2I5Zl"};